import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {GetConstructionSiteAnalysisClient} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

const getConstructionSiteAnalysisClient = new GetConstructionSiteAnalysisClient(SERVICE_URL)

const initialState = {
  loading: false,
  error: null,
  analysis: null,
  selectedConstructionSiteId: null,
}

export const getConstructionSiteAnalysis = createAsyncThunk(
  'workstatus/getConstructionSiteAnalysis',
  async (constructionSiteId, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setError(null))
      const data = await getConstructionSiteAnalysisClient.getConstructionSiteAnalysis(constructionSiteId)
      dispatch(setAnalysis(data))
      return data
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error?.message ?? 'An error occurred'))
      throw error
    }
  }
)

const workstatusSlice = createSlice({
  name: 'workstatus',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setAnalysis: (state, action) => {
      state.analysis = action.payload
      state.loading = false
    },
    setSelectedConstructionSiteId: (state, action) => {
      state.selectedConstructionSiteId = action.payload
      state.analysis = null
    },
    resetWorkStatus: (state) => {
      Object.assign(state, initialState)
    },
  },
})

export const {setLoading, setError, setAnalysis, setSelectedConstructionSiteId, resetWorkStatus} =
  workstatusSlice.actions

export const selectWorkStatusLoading = (state) => state.workstatus.loading
export const selectWorkStatusError = (state) => state.workstatus.error
export const selectWorkStatusAnalysis = (state) => state.workstatus.analysis
export const selectSelectedConstructionSiteId = (state) => state.workstatus.selectedConstructionSiteId

export default workstatusSlice.reducer
